import { ImageSize, Layer } from "./types";

export const LAYERS: Layer[] = ["background", "middle", "foreground"];

export const SIZE_POOLS: ImageSize[] = ["xs", "sm", "md", "lg", "xl"];

export const LAYER_FACTORS: { [key in Layer]: number } = {
  foreground: 0,
  middle: 0.25,
  background: 0.5,
};

export const TRANSLATION_AMPLITUDE = 0.5;

// export const ROW_HEIGHT_FRACTION = 0.75;
export const ROW_HEIGHT_FRACTION = 1;

// We will multiply the relevant layer factor by this to get a number where foreground is the largest, and background the smallest
export const getLayerOffset = (layer: Layer): number => {
  const maxFactor = Math.max(...Object.values(LAYER_FACTORS));
  const f = LAYER_FACTORS[layer];
  const offsetY = ((maxFactor - f) * window.innerHeight);
  return offsetY;
}

export const LAYOUT_TEMPLATE = [
  {
    cols: 2,
    sizes: ["md", "lg"],
  },
  {
    cols: 3,
    sizes: ["sm", "md"],
  },
]

// export const safelistTailwindClasses = [
//   "row-start-1", "row-end-1", "row-start-2", "row-end-2", "row-start-3", "row-end-3", "row-start-4", "row-end-4", "row-start-5", "row-end-5", "row-start-6", "row-end-6", "row-start-7", "row-end-7", "row-start-8", "row-end-8", "row-start-9", "row-end-9", "row-start-10", "row-end-10", "row-start-11", "row-end-11", "row-start-12", "row-end-12",
//   "row-start-13", "row-end-13", "row-start-14", "row-end-14", "row-start-15", "row-end-15", "row-start-16", "row-end-16", "row-start-17", "row-end-17", "row-start-18", "row-end-18", "row-start-19", "row-end-19", "row-start-20", "row-end-20",
//   "col-start-1", "col-start-2", "col-start-3", "col-start-4", "col-start-5", "col-start-6", "col-start-7", "col-start-8", "col-start-9", "col-start-10", "col-start-11", "col-start-12",
//   "col-span-1", "col-span-2", "col-span-3", "col-span-4", "col-span-5", "col-span-6",
// ];
